export default {
    route: false,
    drawer: false,
    loading: false,
    page_loading: false,
    alert: null,
    user: null,
    authorization: null,
    columns: null,
    setup: false,
    cleaning_dialog_status: false
}
